<b>Method</b><br>
{{data.logEntry.methodPath}}
<br><br>
<b>Parameters</b><br>
{{data.logEntry.arguments}}
